import Constant from '@/common/constant/Constant';
import { TmpHiddenSysFieldInTicketDetail } from '@/common/constant/SystemField';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import Utils from '@/common/utils/utils';
import {
    currentProjectIsCustomerOfProjectTarget,
    currentProjectIsHelpdeskOfProjectTarget,
} from '@/service/projectService';
import { getPdfTicketDetailAPI, getTicketDetailAPI, deleteAllTicketData, getTicketById, editTicketData, uploadTicketFileToS3 } from '@/service/ticketService';
import { hideLoadingMouse} from '@/common/utils/CustomCursor';


import _, { cloneDeep } from 'lodash';
import moment from 'moment';
import { getAdditionalPermissionsForSave } from '@/component/ticketList/handler/SettingPermissionHandler';
import { I18n, Storage } from 'aws-amplify';
import { getCorporationById } from '@/service/organizationService';
import { getAiAutoLogByTicketId } from '@/service/aiAutoLogService';
import { getPanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaDataContentOperation, createKibanaEditContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { hasKnowledgeChatPermissionInChatThread } from './ListTicketKnowledgeHandler';
import { getTelephoneStatusFromTicket } from '@/component/chatThread/handler/DetailTicketHandler';

export const getTitle = settingTitle => {
    let title = '';
    settingTitle?.forEach(element => {
        if (!element.isBreak) {
            title = title + element.text;
        }
    });
    return title;
};

export const getPanelType = (args) => {
    let {panelList} = args
    let currentPanelIndex = Utils.findIndexInArrayById(args.panelId, panelList);
    if (currentPanelIndex === -1) return '';
    let currentPanel = panelList[currentPanelIndex];
    return currentPanel.type;
};

const getTicketListType = (args) => {
    return getPanelType(args) === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
        ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
        : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST;
};

const findTabInListPanel = (panelId,tabId,panelList) => {
    let tabDetail = {}
    let currentPanel = panelList?.find(panel => {
        return panel.id === panelId;
    });

    if(!Utils.isEmptyObject(currentPanel)){
        const tabList = currentPanel.tabList
        let currentTab = tabList?.find(tab => {
            return tab.id === tabId
        });

        tabDetail = Utils.isEmptyObject(currentTab) ? {} : currentTab

    }

    return tabDetail
}

export const getTicketDetailHandler = async (args, ticketId, panelId, tabId, panelInitData, panelList) => {
    const setAssignList = args?.setAssignList;
    let ticketDetailResult = await getTicketDetailAPI(args.API, ticketId);

    let isViewPermission = hasKnowledgeChatPermissionInChatThread(
        ticketDetailResult.detailTicket,
        args.selectedProject,
        args.currentUserDetail?.id,
        true
    );

    if (!Utils.isEmptyArray(ticketDetailResult?.errors)) {
        const msgError = ticketDetailResult?.errors[0].message?.replace('ApiError==', '');
        if (msgError === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR){
            args.setIsOpenModalReloadPageMain(true);
            return;
        }
    }

    if (Utils.isEmptyObject(ticketDetailResult) || !isViewPermission) {
        args.setIsOpenAccessDeniedPopup(true);
        return;
    }

    let ticket = cloneDeep(ticketDetailResult.detailTicket);
    ticket.dataShareLink = Utils.convertJSONDataToObject(ticketDetailResult.dataShareLink);
    ticket.attachFiles = Utils.convertJSONDataToObject(ticketDetailResult?.attachFiles);
    let formDetail = cloneDeep(Utils.convertJSONDataToObject(ticketDetailResult.formDetail));
    ticket.formDetail = formDetail;
   
    let currentTab = {};

    if(!Utils.isEmptyArray(panelList)){
        currentTab = findTabInListPanel( panelId, tabId,panelList);
    }
   
    if (!Utils.isEmptyObject(panelInitData) && args.isFromEditTicket) {
        let newCurrentPanelInitData = cloneDeep(panelInitData);
        newCurrentPanelInitData.formData = {};
        args.setCurrentPanelInitData(newCurrentPanelInitData);
    }
    
    // update titleLineNumber
    args.setSettingTitleLineNumber(formDetail.structure?.titleLineNumber);
    if (args.setSplitPdf) {
        args.setSplitPdf(Boolean(formDetail.structure?.splitPdf));
    }
    
    
    ticket.usingFormName = ticketDetailResult.usingFormName;
    // LogKibana
    if (args.lastUserAction && args.lastUserAction !== LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) {
        let formDetailId = Utils.convertJSONDataToObject(ticketDetailResult?.formDetail)?.id;
        let contentTypes = LogKibanaConstant.CONTENT_TYPES_TICKET.QA;
        let dataLog = {
            corporationDetail: args.corporationDetail,
            projectDetail: args.selectedProject,
            rootCorporationDetail: {
                id: ticket.affiliationOrganization
            },
            rootProjectDetail: {
                id: ticket.projectOrigin,
                name: ticket.projectOriginName
            },
            userDetail: args.currentUserDetail,
            contentTypes: contentTypes,
            ticketDetail: ticket,
            metaData: {
                formDetailId: formDetailId,
                selectedProject: args.selectedProject,
                ticketType: ticket.ticketType,
            }
        };
        if(currentTab.isViewByList){
            dataLog.viewBy = '検索'
        }
        let operationScreen = LogKibanaConstant.OPERATION_SCREEN.SOLUTION_DESK;
        let logKibanaData = createKibanaDataContentOperation(
            args.lastUserAction,
            dataLog,
            operationScreen);
        
        if (!Utils.isEmptyObject(logKibanaData)) {
            let param = {
                logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW,
                logKibanaData: logKibanaData
            };
             createKibanaLogAPI(args.API, param);
            args.setLastUserAction(null);
        }
        
       
    }

    // Init setting permission
    let initDataSettingDefaults = {
        viewPermission: ticket.viewPermission ? ticket.viewPermission : [],
        editPermission: ticket.editPermission ? ticket.editPermission : [],
        additionalViewPermission: ticket.additionalViewPermission,
        additionalEditPermission: ticket.additionalEditPermission,
        chatPermission: ticket.chatPermission
    };
    let dataSettingDefaults = getSettingPermissionDefault(initDataSettingDefaults, panelId, tabId, panelInitData);
    args.setDataSettingDefaults(dataSettingDefaults);

    const createAt = new Date(ticket.createdAt);
    const updatedAt = new Date(ticket.updatedAt);
    ticket.createTime = moment(createAt).format('YYYY/MM/DD HH:mm');
    ticket.updatedTime = moment(updatedAt).format('YYYY/MM/DD HH:mm');

    const title = getTitle(ticket.settingTitle);
    if (Utils.isEmptyArray(ticket.settingTitle)) {
        args.setSettingTitle([]);
    } else {
        args.setSettingTitle([...ticket.settingTitle]);
    }
    ticket.outline = title
    // Update detail ticket
    let footPrint = !Utils.isEmpty(ticket.footPrint) || !Utils.isEmptyArray(ticket.footPrint) ? ticket.footPrint : [];

    if (args.currentUserDetail.id !== ticket.creator && !footPrint.includes(args.currentUserDetail.id)){
        footPrint.push(args.currentUserDetail.id);
        let requestParams =  {
            currentUserMail: args.currentUserDetail.mail,
            ticketId: ticket.id,
            corporationId: ticket.affiliationOrganization,
            ticketType: ticket.ticketType,
            footPrint: footPrint,
            updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_FOOTPRINT,
        }

        await editTicketData(args.API, requestParams);
        let panelType = getTicketListType(args);
        if (panelType !== Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST) {
            args.reloadTicketListByPanelType({
                panelType: panelType
            });
        }
    }

    // prepare bookmark data
    if (
        [
            Constant.TICKET_TYPE.KNOWLEDGE,
            Constant.TICKET_TYPE.MASTER_KNOWLEDGE,
            Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE,
            Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE
        ].includes(ticket.ticketType)
    ) {
        let bookmarkData = Utils.convertJSONDataToObject(ticket?.bookmarkInfo)

        ticket.privateBookmarkData = bookmarkData.privateBookmarkData
        ticket.shareBookmarkData = bookmarkData.shareBookmarkData
        ticket.totalPrivateBookmark = bookmarkData.totalPrivateBookmark
        ticket.isBookmarkedDefaultBookmark = bookmarkData.isBookmarkedDefaultBookmark
        ticket.bookmarkListText = bookmarkData.bookmarkListText

        delete ticket.bookmarkInfo
    }

    args.setDetailTicket(ticket);

    // update ticket outline & delete line through
    const isUpdateLineThroughToDeletedTicket = !Utils.isEmptyString(ticket.deletedAt) && !currentTab.isTicketDeleted;
    ticket.isUpdateLineThroughToDeletedTicket = isUpdateLineThroughToDeletedTicket;

    args.setTicketOutline(ticket.outline);
    let isB2BCustomer = currentProjectIsCustomerOfProjectTarget(
        args.listB2BHelpdesk,
        ticket.affiliationProject
    );
    let isB2BHelpdesk = currentProjectIsHelpdeskOfProjectTarget(
        args.listB2BCustomer,
        ticket.affiliationProject
    );
    let fieldListDefaultData = await getDefaultDataEditTicket(
        args,
        ticketDetailResult,
        isB2BCustomer,
        isB2BHelpdesk,
        setAssignList
    );
    args.setFieldListDefaultData(fieldListDefaultData);

    // Update field list data
    if (ticketDetailResult?.fieldListData) {
        let listField = JSON.parse(ticketDetailResult?.fieldListData);
        listField = listField.filter(field => {
            // hide AI_TELEPHONE_APPLICABLE_PHONE_NUMBER field if not in the same project
            if (field?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_APPLICABLE_PHONE_NUMBER && ticket?.affiliationProject !== args?.selectedProject?.id) {
                return false;
            }
            return !TmpHiddenSysFieldInTicketDetail.includes(field?.sysField);
        });

        listField.sort((a, b) => {
            // attachment always at bottom
            if (a.sysField === 'attachments') return 1;
            if (b.sysField === 'attachments') return -1;
        });

        args.setListFieldData([...listField]);
    }

    return ticket;
};

export const handleInitPdfTicketDetail = async (args) => {
    // getTicketPdfDetail
    args.setIsLoading(true);
    
    //get ticket detail
    let ticketPdf = await getPdfTicketDetailAPI(args.API, args.ticketId, args.projectInuseDetail.id);
    ticketPdf.dataShareLink = Utils.convertJSONDataToObject(ticketPdf.dataShareLink);

    // validate
    if(Utils.isEmptyObject(ticketPdf)) {
        args.setIsLoading(false);
        args.setIsShowPopupReloadPage(true);
        return;
    }
    if (ticketPdf.errorMessage && ticketPdf.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        args.setIsLoading(false);
        args.setIsOpenModalReloadPage(true);
        return;
    }

    let isHasViewPermission = hasKnowledgeChatPermissionInChatThread(
        ticketPdf,
        args.projectInuseDetail,
        args.currentUserDetail?.id,
        true
    );

    let isNotCreatorDraftedTicket =
        args.currentUserDetail.id !== ticketPdf.creator &&
        [Constant.TICKET_PUBLIC.PRIVATE, Constant.TICKET_PUBLIC.DRAFT].includes(ticketPdf?.public);
    
    if (!isHasViewPermission || isNotCreatorDraftedTicket) {
        args.setIsOpenAccessDeniedPopup(true);
        return;
    }

    const createAt = new Date(ticketPdf.createdAt);
    const updatedAt = new Date(ticketPdf.updatedAt);
    ticketPdf.createTime = moment(createAt).format('YYYY/MM/DD HH:mm');
    ticketPdf.updatedTime = moment(updatedAt).format('YYYY/MM/DD HH:mm');

    const hyperLinkExtractText = Utils.convertJSONDataToObject(ticketPdf.hyperLinkExtractText);
    let fileExtractText = hyperLinkExtractText.dataValue;
    fileExtractText.type = Constant.S3_FILE_TYPE.TICKET_FILE;
    
    const extractTextLink = getLinkDownloadFileFromS3(
        fileExtractText,
        Utils.convertJSONDataToObject(hyperLinkExtractText.ticketDetail),
        null, null, false, true
    );
    ticketPdf.extractTextUrl = extractTextLink;

    const hyperLinkVector = Utils.convertJSONDataToObject(ticketPdf.hyperLinkVector);
    let fileLinkVector = hyperLinkVector.dataValue;
    fileLinkVector.type = Constant.S3_FILE_TYPE.TICKET_FILE;
    const vectorLink = getLinkDownloadFileFromS3(
        fileLinkVector,
        Utils.convertJSONDataToObject(hyperLinkVector.ticketDetail),
        null, null, false, true
    );
    ticketPdf.vectorDataUrl = vectorLink;

    // prepare bookmark data
    let bookmarkData = Utils.convertJSONDataToObject(ticketPdf?.bookmarkInfo)

    ticketPdf.privateBookmarkData = bookmarkData.privateBookmarkData
    ticketPdf.shareBookmarkData = bookmarkData.shareBookmarkData
    ticketPdf.totalPrivateBookmark = bookmarkData.totalPrivateBookmark
    ticketPdf.isBookmarkedDefaultBookmark = bookmarkData.isBookmarkedDefaultBookmark
    ticketPdf.bookmarkListText = bookmarkData.bookmarkListText
    
    delete ticketPdf.bookmarkInfo

    args.setDetailTicket(ticketPdf);
    
    args.setTicketOutline(ticketPdf.outline);
    // check & update delete line through to activeTab
    if(!Utils.isEmptyArray(args?.panelList)){
        const currentTab = findTabInListPanel(
            args?.panelId,
            args?.tabId,
            args?.panelList
        );

        const isUpdateLineThroughToDeletedTicket =
            !Utils.isEmptyString(ticketPdf.deletedAt)
            && !currentTab?.isTicketDeleted;
        
        if (isUpdateLineThroughToDeletedTicket) {
            updateTabNameAfterEditTicket(args, ticketPdf.outline, args.panelId, ticketPdf.id, isUpdateLineThroughToDeletedTicket);
        }
    }

    const defaultListFields = ticketPdf.defaultFields.map(field => {
        let convertedField = Utils.convertJSONDataToObject(field);
        if (convertedField.id === 'attachment') {
            convertedField = {
                ...convertedField,
                pageNo: ticketPdf.ticketType == Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE ?
                    `${ticketPdf?.outline?.match(/\((\d+)\/\d+\)$/)[1]}` : '',
                dataValue: {
                    ...convertedField.dataValue,
                    fileName: ticketPdf.outline,
                    fileUrl : convertedField.dataValue.fileUrl
                }
            }
        }

        return convertedField;
    });
    args.setFieldListDefaultData(defaultListFields)

    // setCorporationAffiliationTicket
    const corporationAffiliation = await getCorporationById(args.API, ticketPdf.affiliationOrganization);
    args.setCorporationAffiliationTicket(corporationAffiliation);

    // update footprint
    if (ticketPdf.footPrint) {
        let currentFootprintList = Utils.convertJSONDataToObject(ticketPdf.footPrint);

        if(args.currentUserDetail.id !== ticketPdf.creator && !currentFootprintList.includes(args.currentUserDetail.id)){
            currentFootprintList.push(args.currentUserDetail.id);
            let requestParams =  {
                currentUserId: args.currentUserDetail.id,
                currentUserMail: args.currentUserDetail.mail,
                ticketId: ticketPdf.id,
                corporationId: ticketPdf.affiliationOrganization,
                ticketType: ticketPdf.ticketType,
                footPrint: currentFootprintList,
                updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_FOOTPRINT_FILE_AND_PAGE_KNOWLEDGE,
            }
    
            editTicketData(args.API, requestParams);
        }
    }

    // set viewPermission 3 field: Extract/Vector/Token permission
    let isB2BCustomer = currentProjectIsCustomerOfProjectTarget(
        args.listB2BHelpdesk,
        ticketPdf.affiliationProject
    );
    let isB2BHelpdesk = currentProjectIsHelpdeskOfProjectTarget(
        args.listB2BCustomer,
        ticketPdf.affiliationProject
    );

    const checkArgs = {
        ...args,
        selectedProject: args.projectInuseDetail,
        isProjectManager: args.projectInuseDetail.isProjectManager
    }

    let {
        hasEditSettingPermission,
        hasEditFieldPermissions,
    } = checkHasPermission(checkArgs, ticketPdf, isB2BCustomer, isB2BHelpdesk);

    args.setHasEditSettingPermissions(hasEditSettingPermission);
    args.setHasEditFieldPermissions(hasEditFieldPermissions);

    let formDetailObject = Utils.convertJSONDataToObject(ticketPdf.formDetail);
    args.setFormDetail(formDetailObject);

    args.setIsLoading(false);
}

/**
 * getSettingPermissionDefault
 * get default setting permission in add/detail ticket knowledge
 * @param {*} ticket 
 * @param {*} panelId 
 * @param {*} tabId 
 * @param {*} panelInitData 
 * @returns 
 */
export const getSettingPermissionDefault = (initSettingDefault, panelId, tabId, panelInitData) => {
    let dataSettingDefaults = {
        ...initSettingDefault
    };

    let currentPanelInitDataRes = getPanelInitData(panelId, tabId, panelInitData);
    if (currentPanelInitDataRes && currentPanelInitDataRes.settingPermission && !Utils.isEmptyObject(currentPanelInitDataRes.settingPermission)) {
        let oldSetting = {...currentPanelInitDataRes.settingPermission};
        if (!Utils.isEmptyArray(oldSetting.viewPermission)) {
            dataSettingDefaults.viewPermission = oldSetting.viewPermission.map(item => item.value);
        }
        if (!Utils.isEmptyArray(oldSetting.editPermission)) {
            dataSettingDefaults.editPermission = oldSetting.editPermission.map(item => item.value);
        }

        dataSettingDefaults.additionalViewPermission = JSON.stringify(getAdditionalPermissionsForSave(oldSetting.additionalViewPermission));
        dataSettingDefaults.additionalEditPermission = JSON.stringify(getAdditionalPermissionsForSave(oldSetting.additionalEditPermission));
        
        if (oldSetting.chatPermission) {
            dataSettingDefaults.chatPermission = oldSetting.chatPermission;
        }
    }

    return dataSettingDefaults;
}

export const getDefaultDataEditTicket = async (
    args,
    ticketDetailResult,
    isB2BCustomer,
    isB2BHelpdesk,
    setAssignList
) => {
    if (Utils.isEmptyObject(ticketDetailResult)) return;
    let ticket = cloneDeep(ticketDetailResult.detailTicket);
    let selectedProject = args.selectedProject;
    const mappingDataIdToIdObj = Utils.convertJSONDataToObject(
        ticketDetailResult?.mappingDataIdToIdObj
    );
    args.setMapDataIdToId({ ...mappingDataIdToIdObj });
    let formDetailObject = Utils.convertJSONDataToObject(ticketDetailResult.formDetail);
    args.setFormDetail(formDetailObject);
    args.setAITelephoneSelectedData(preValue => {
        if (!Utils.isEmptyObject(preValue)) {
            return {
                ...preValue,
                selectedFormDetail: formDetailObject
            };
        }
        return {
            selectedFormDetail: formDetailObject
        };
    });
    let fieldOrderInForm = {};

    if (!Utils.isEmptyObject(formDetailObject.structure)) {
        for (const [structureKey, structureValue] of Object.entries(formDetailObject.structure)) {
            if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
            }
        }
    }

    let {
        hasEditSettingPermission,
        hasEditFieldPermissions,
        hasChatPermission,
        hasViewPermission,
    } = checkHasPermission(args, ticket, isB2BCustomer, isB2BHelpdesk);

    args.setHasEditSettingPermissions(hasEditSettingPermission);
    args.setHasEditFieldPermissions(hasEditFieldPermissions);
    args.setHasChatPermission(hasChatPermission);
    args.setHasViewPermission(hasViewPermission);

    let fieldListDefaultData = [];
    let isExistPersonInChargeField = false;
    if (ticketDetailResult?.fieldListData) {
        let listField = cloneDeep(Utils.convertJSONDataToObject(ticketDetailResult?.fieldListData));

        //filter field is active
        if (formDetailObject.definition !== Constant.FORM_DEFINITION.SYSTEM) {
            listField = listField?.filter(field => {
                if (
                    field.definition === Constant.FORM_DEFINITION.SYSTEM ||
                    field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                ) {
                    return true;
                }
                const usingProjectOfField = Utils.convertJSONDataToObject(field?.usingProjects);
                if (Utils.isEmptyArray(usingProjectOfField)) {
                    return false;
                } else {
                    return field?.usingProjects?.includes(formDetailObject.affiliationProject);
                }
            });
        }

        listField.forEach(fieldData => {
            fieldData.defaultValue =
                fieldData.type === Constant.FORM_TYPE.FIELD_TAG
                    ? fieldData.defaultValue
                    : fieldData.value;

            if (fieldData.sysField === Constant.SYS_FIELD.PERSON_IN_CHARGE) {
                isExistPersonInChargeField = true;
            }
            // hide AI_TELEPHONE_APPLICABLE_PHONE_NUMBER field if not in the same project
            if (fieldData?.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_APPLICABLE_PHONE_NUMBER && ticket?.affiliationProject !== args?.selectedProject?.id) {
                return false;
            }

            if (
                args.currentUserDetail?.id === ticket.creator ||
                args.selectedProject?.id === ticket.affiliationProject
            ) {
                if (hasEditFieldPermissions) {
                    fieldData.structure.publicForCustomer = 3;
                } else {
                    fieldData.structure.publicForCustomer = 2;
                }
                fieldListDefaultData.push(fieldData);
            } else {
                if (!hasEditFieldPermissions && fieldData.structure.publicForCustomer === 3) {
                    fieldData.structure.publicForCustomer = 2;
                }

                if (hasEditFieldPermissions && fieldData.publicForCustomer === 3) {
                    fieldData.structure.publicForCustomer = 3;
                }

                if (args.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE && 
                    fieldData.publicForCustomer !== 3
                ) {
                    fieldData.structure.publicForCustomer = 3;
                }

                if (fieldData.structure.publicForCustomer !== 1) {
                    fieldListDefaultData.push(fieldData);
                }
            }
        });

        fieldListDefaultData = fieldListDefaultData
            .filter(field => {
                return !TmpHiddenSysFieldInTicketDetail.includes(field.sysField);
            })
            .sort((a, b) => {
                // attachment always at bottom
                if (a.sysField === 'attachments') return 1;
                if (b.sysField === 'attachments') return -1;
                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }
                return a.order[selectedProject.id] - b.order[selectedProject.id];
            });
    }
    
    return fieldListDefaultData;
};

export const checkHasPermission = (args, ticketDetail, isB2BCustomer, isB2BHelpdesk) => {
    let editPermission = ticketDetail.editPermission;
    let chatPermission = ticketDetail.chatPermission;
    let viewPermission = ticketDetail.viewPermission;
    const isProjectManager = args.isProjectManager;
    const projectInuseDetail = args.selectedProject;

    let additionalViewPermission = Utils.convertJSONDataToObject(ticketDetail.additionalViewPermission);

    let hasEditSettingPermission = false;
    let hasEditFieldPermissions = false;
    let hasChatPermission = false;
    let hasViewPermission = false;

    // current user is creator
    if (
        args.currentUserDetail?.id === ticketDetail.creator &&
        args.selectedProject?.id === ticketDetail.affiliationProject
    ) {
        hasEditFieldPermissions = true;
    }

    let ticketAffiliationProjectId = ticketDetail.affiliationProject;
    if (isProjectManager && ticketAffiliationProjectId === projectInuseDetail.id) {
        hasEditSettingPermission = true;
        hasEditFieldPermissions = true;
    }

    // ticket public edit permission for all
    if (editPermission?.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) {
        hasEditFieldPermissions = true;
    }

    if (
        chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC ||
        chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION
    ) {
        hasChatPermission = true;
    }
    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) hasViewPermission = true;

    if (
        additionalViewPermission.b2bCustomerProject.includes(args.selectedProject.id) ||
        additionalViewPermission.b2bHelpdeskProject.includes(args.selectedProject.id) ||
        additionalViewPermission.baseProject.includes(args.selectedProject.id) ||
        additionalViewPermission.guestCustomerProject.includes(args.selectedProject.id) ||
        additionalViewPermission.orgProject.includes(args.selectedProject.id)
        
    ) {
        hasViewPermission = true;
    }

    if (args.selectedProject?.id === ticketDetail.affiliationProject) {
        if (
            editPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT) ||
            editPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)
        ) {
            hasEditFieldPermissions = true;
        }

        if (
            chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT ||
            chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG
        ) {
            hasChatPermission = true;
        }

        if (
            viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT) ||
            viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)
        ) {
            hasViewPermission = true;
        }
    }

    if (
        args.corporationDetail?.id === ticketDetail.affiliationOrganization &&
        (![Constant.PROJECT_TYPE.CUSTOMER].includes(args.selectedProject?.type))
    ) {
        if (editPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)) {
            hasEditFieldPermissions = true;
        }

        if (chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG) {
            hasChatPermission = true;
        }

        if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)) {
            hasViewPermission = true;
        }
    }

    if (isB2BCustomer) {
        if (editPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER)) {
            hasEditFieldPermissions = true;
        }

        if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER)) {
            hasViewPermission = true;
        }
    }

    if (isB2BHelpdesk) {
        if (editPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT)) {
            hasEditFieldPermissions = true;
        }

        if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT)) {
            hasViewPermission = true;
        }
    }

    let additionalEditPermissions = ticketDetail.additionalEditPermission;
    additionalEditPermissions = Utils.convertJSONDataToObject(additionalEditPermissions);
    if (!Utils.isEmptyObject(additionalEditPermissions)) {
        for (let [key, value] of Object.entries(additionalEditPermissions)) {
            if (value.includes(args.selectedProject?.id)) {
                hasEditFieldPermissions = true;
                break;
            }
        }
    }

    if (chatPermission === Constant.KNOWLEDGE_CHAT_PERMISSION.NO) {
        hasChatPermission = false;
    }

    return {
        hasEditSettingPermission,
        hasEditFieldPermissions,
        hasChatPermission,
        hasViewPermission,
    };
};

const handleEditFileUpload = async (
    fileUploadList,
    updateData,
    setFileUploading,
    setFileUploadList,
    fileUpdatedList
) => {
    let uploadResult = {
        fileListSuccess: [],
        suffixOfAttachments: {}
    };
    let updateFileUploadResult = {};
    if (fileUploadList.length > 0) {
        uploadResult = await uploadTicketFileToS3(
            {
                fileUploadList: fileUploadList,
                affiliationOrganization: updateData.affiliationOrganization,
                fileUpdatedList
            },
            setFileUploading
        );

        // No files are deleted
        if (fileUpdatedList.length === 0) {
            let suffixOfAttachments = uploadResult?.suffixOfAttachments;
            updateFileUploadResult.attachment = JSON.stringify({
                value: [...uploadResult.fileListSuccess]
            });
            updateFileUploadResult.suffixOfAttachments = JSON.stringify({
                value: suffixOfAttachments
            });
            setFileUploadList([]);
        }
        updateFileUploadResult.newFileList = [...uploadResult.fileListSuccess]
    }

    if (fileUpdatedList.length !== 0) {
        let listFileDelete = fileUpdatedList.filter(file => {
            return file.isDelete;
        });

        let listFilePdfUpdated = fileUpdatedList.filter(file => {
            return !file.isDelete && file.isPdf;
        });

        updateFileUploadResult.listFileDelete = listFileDelete;
        updateFileUploadResult.listFilePdfUpdated = listFilePdfUpdated;
        
        if (listFileDelete.length > 0) {
            listFileDelete.forEach(file => {
                let fileNameData = getFileNameAndExtension(file?.fileName);
                try {
                    Storage.remove(file.fileUrl);
                    if (fileNameData.name && fileNameData.extension) {
                        Storage.remove(`${fileNameData.name}_thumbnail_large.${fileNameData.extension}`);
                        Storage.remove(`${fileNameData.name}_thumbnail_medium.${fileNameData.extension}`);
                        Storage.remove(`${fileNameData.name}_thumbnail_small.${fileNameData.extension}`);
                    }
                } catch (e) {
            
                }
            });
        }
        let existingFileList = fileUpdatedList.filter(file => {
            if (file.isDelete) {
                return false;
            } else {
                return true;
            }
        });
        let suffixOfAttachments = uploadResult?.suffixOfAttachments;
        const newExistingFileList = existingFileList.map(file => {
            delete file.__typename;
            const lastDot = file.fileName.lastIndexOf('.');
            const fileExtension = file.fileName.substring(lastDot + 1).toLowerCase();
            if (suffixOfAttachments[`${fileExtension}`]) {
                suffixOfAttachments[`${fileExtension}`] =
                    suffixOfAttachments[`${fileExtension}`] + 1;
            } else {
                suffixOfAttachments[`${fileExtension}`] = 1;
            }
            return file;
        });

        updateFileUploadResult.attachment = JSON.stringify({
            value: [...uploadResult.fileListSuccess, ...newExistingFileList]
        });
        updateFileUploadResult.suffixOfAttachments = JSON.stringify({
            value: suffixOfAttachments
        });
        setFileUploadList([]);
    }
    return updateFileUploadResult;
};

export const submitUpdateTicketKnowledge = async (
    API,
    updateData,
    setIsLoading,
    setIsDisplayEditTicket,
    fileUploadList,
    fileUpdatedList,
    setFileUploading,
    setFileUploadList,
    detailTicket,
    fieldListDefaultData,
    formData,
    currentUserDetail,
    editedFieldValue,
    mapDataIdToId,
    isUpdateDraft,
    argsAll
) => {
    let editUploadResult = await handleEditFileUpload(
        fileUploadList,
        updateData,
        setFileUploading,
        setFileUploadList,
        fileUpdatedList
    );
    editedFieldValue[`${mapDataIdToId['attachment']}`] = editUploadResult.attachment
    editedFieldValue[`${mapDataIdToId['suffixOfAttachments']}`] = editUploadResult.suffixOfAttachments;
  
    let viewPermissions = argsAll.viewPermissions;
    let editPermissions = argsAll.editPermissions;
    let additionalViewPermissions = argsAll.additionalViewPermissions;
    let additionalEditPermissions = argsAll.additionalEditPermissions;
    let chatPermission = argsAll.chatPermission;

    if (
        argsAll.hasEditSettingPermissions &&
        (Utils.isEmptyArray(viewPermissions) ||
        Utils.isEmptyArray(editPermissions) ||
        Utils.isEmptyString(chatPermission))
    ) {
        return;
    }
    let viewPermissionOfTicket = detailTicket.viewPermission;
    let additionalViewPermissionOfTicket = Utils.convertJSONDataToObject(detailTicket.additionalViewPermission);
    let viewPermissionsSave = viewPermissions.map(p => p.value);
    let editPermissionsSave = editPermissions.map(p => p.value);
    let additionalViewPermissionsSave = getAdditionalPermissionsForSave(additionalViewPermissions);
    let additionalEditPermissionsSave = getAdditionalPermissionsForSave(additionalEditPermissions);
    let isEditPublicRange = false;
    if(argsAll.hasEditSettingPermissions &&(!Utils.areArraysEqual(viewPermissionOfTicket,viewPermissionsSave)|| !areObjectsEqual(additionalViewPermissionOfTicket,additionalViewPermissionsSave))){
        isEditPublicRange = true
    };

    let viewPermissionLabel = ''
    viewPermissions.forEach(p => {
        if(Utils.isEmptyString(viewPermissionLabel)){
            viewPermissionLabel = p.displayName
        }else{
            viewPermissionLabel = viewPermissionLabel +', ' + p.displayName
        }
    })


    let additionalViewPermissionLabel = ''

    additionalViewPermissions.forEach(p => {
        let permissionName = Utils.convertJSONDataToObject(p.name)?.jp?.text
        permissionName = Utils.isEmptyString(permissionName) ? null : permissionName
        if(Utils.isEmptyString(additionalViewPermissionLabel)){
            additionalViewPermissionLabel = permissionName
        }else{
            additionalViewPermissionLabel = additionalViewPermissionLabel +', ' + permissionName
        }
    })
    
    let publicRangeStr = `${viewPermissionLabel}`
    if(!Utils.isEmptyString(additionalViewPermissionLabel)){
        publicRangeStr = `${viewPermissionLabel}, ${additionalViewPermissionLabel}`
    }
    

    let submitUserEditTicketRequestDto = {
        ticketId: detailTicket.id,
        corporationId: currentUserDetail.affiliationOrganization,
        ticketType: detailTicket.ticketType,
        currentUserMail: currentUserDetail.mail,
        currentUserId: currentUserDetail.id,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_FIELD_TICKET,
        listFieldEdited: JSON.stringify(argsAll.listFieldEdited),
        mapDataIdToId: JSON.stringify(mapDataIdToId),
        editedFieldValue: JSON.stringify(editedFieldValue),
        updateAttachFile: JSON.stringify({
            newFileList:editUploadResult.newFileList,
            listFileDelete: editUploadResult.listFileDelete,
            listFilePdfUpdated: editUploadResult.listFilePdfUpdated
        }),
        isHelpDesk: true,
        formId: argsAll.formDetail.id,
        viewPermission: viewPermissionsSave,
        additionalViewPermission: JSON.stringify(additionalViewPermissionsSave),
        editPermission: editPermissionsSave,
        additionalEditPermission: JSON.stringify(additionalEditPermissionsSave),
        chatPermission: chatPermission,
        sessionId: localStorageUtil.getSessionBrowserId(),
        isServicesPDFOfCorpOn: detailTicket?.convertPDFOrg === 1 ? true : false
    };

    if (
        !Utils.isEmptyString(argsAll.newAssignee) &&
        argsAll?.newAssignee !== argsAll?.detailTicket?.personInChargeInfo?.id
    ) {
        submitUserEditTicketRequestDto.currentAssigneeId =
            argsAll?.detailTicket?.personInChargeInfo?.id;
        submitUserEditTicketRequestDto.newAssigneeId = argsAll?.newAssignee;
    }


    let logRequestDto = createKibanaEditContentOperation({
        corporationDetail : argsAll.corporationDetail, projectDetail : argsAll.selectedProject, userDetail : argsAll.currentUserDetail, ticketDetail : argsAll?.detailTicket, formDetail : argsAll.formDetail,publicRange : publicRangeStr
    });

    let actionDetail = isEditPublicRange?  'edit(changeAccessRange)' : 'edit'
    logRequestDto.actionDetail = actionDetail
    const editTicketDataRes = await editTicketData(API, submitUserEditTicketRequestDto);
    if (editTicketDataRes?.errorCode === 'COMMSG030') {
        argsAll.setIsOpenModalReloadPage(true);
        argsAll.setIsLoading(false);
        return ;
    }

    // Edit duplicate name
    switch (editTicketDataRes?.errorCode) {
        case Constant.MSG_SD_DUPLICATED_SCRIPT_TITLE: {
            const outlineField = fieldListDefaultData?.find(
                field => field?.sysField?.toLowerCase() === Constant.SYS_FIELD.OUTLINE
            );
            if (outlineField) {
                argsAll?.setErrorEditTicket(outlineField.id, {
                    type: 'isValidDuplicateTitle',
                    message: I18n.get('MSG-SD-DUPLICATED-SCRIPT-TITLE')
                });
            }
            argsAll.setIsLoading(false);
            return {
                errorCode: editTicketDataRes?.errorCode
            };
        }
        case Constant.MSG_APP_NAME_DUPLICATED: {
            const appNameField = fieldListDefaultData?.find(
                field => field?.sysField?.toLowerCase() === Constant.SYS_FIELD.BUSINESS_APP_NAME
            );
            if (appNameField) {
                argsAll?.setErrorEditTicket(appNameField?.id, {
                    type: 'isValidDuplicateAppName',
                    message: I18n.get('MSG-APP-NAME-DUPLICATED')
                });
            }
            argsAll.setIsLoading(false);
            return {
                errorCode: editTicketDataRes?.errorCode
            };
        }
        default: {
            let param = {
                logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT,
                logKibanaData: logRequestDto
            };
            createKibanaLogAPI(argsAll.API, param);
            setIsDisplayEditTicket(false);
            return editTicketDataRes;
        }
    }
};

export const updateTabNameAfterEditTicket = (argsAll, newOutline, panelId, ticketId, isTicketDeleted = false) => {
    if (argsAll?.setPanelList) {
        argsAll?.setPanelList((prevPanelList)=>{
            let currentPanelList = cloneDeep(prevPanelList);
            if (Utils.isEmptyArray(currentPanelList)) return [];

            let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelList);
            if (currentPanelIndex === -1) return;
        
            let currentPanel = currentPanelList[currentPanelIndex];
        
            if (Utils.isEmptyArray(currentPanel.tabList)) return;
            let currentTabIndex = Utils.findIndexInArrayById(ticketId, currentPanel.tabList);
            if (currentTabIndex === -1) return;
        
            // Update ticket outline
            currentPanelList[currentPanelIndex].tabList[currentTabIndex].ticketOutline = newOutline;
        
            // Update through line to softDeleted ticket
            if (isTicketDeleted) {
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].isTicketDeleted = isTicketDeleted;
            }
            return currentPanelList
        })
    }
};

export const isSettingPermissionChanged = (currentDetailTicket, latestDetailTicket) => {
    if (Utils.isEmptyObject(latestDetailTicket)) {
        return true;
    }

    let currentViewPermission = currentDetailTicket.viewPermission;
    let currentEditPermission = currentDetailTicket.editPermission;
    let currentAdditionalViewPermission = currentDetailTicket.additionalViewPermission;
    let currentAdditionalEditPermission = currentDetailTicket.additionalEditPermission;
    let currentChatPermission = currentDetailTicket.chatPermission;

    let latestViewPermission = latestDetailTicket.viewPermission;
    let latestEditPermission = latestDetailTicket.editPermission;
    let latestAdditionalViewPermission = latestDetailTicket.additionalViewPermission;
    let latestAdditionalEditPermission = latestDetailTicket.additionalEditPermission;
    let latestChatPermission = latestDetailTicket.chatPermission;

    let isEqualViewPermission = _.isEqual(currentViewPermission, latestViewPermission);
    let isEqualEditPermission = _.isEqual(currentEditPermission, latestEditPermission);
    let isEqualAdditionalViewPermission = _.isEqual(
        currentAdditionalViewPermission,
        latestAdditionalViewPermission
    );
    let isEqualAdditionalEditPermission = _.isEqual(
        currentAdditionalEditPermission,
        latestAdditionalEditPermission
    );
    let isEqualChatPermission = currentChatPermission === latestChatPermission;

    if (
        !isEqualViewPermission ||
        !isEqualEditPermission ||
        !isEqualAdditionalViewPermission ||
        !isEqualAdditionalEditPermission ||
        !isEqualChatPermission
    ) {
        return true;
    }

    return false;
};

export const submitSoftDeleteKnowledgeTicket = async (API, detailTicket, deletedAt, currentUserDetail, argsAll, fieldOutlineIdUpdate = []) => {
    let submitSoftDeleteTicketRequestDto = {
        ticketId: detailTicket.id,
        currentUserId: currentUserDetail.id,
        currentUserMail: currentUserDetail.mail,
        corporationId: currentUserDetail.affiliationOrganization,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_DELETED_AT,
        ticketType: detailTicket.ticketType,
        deletedAt: deletedAt
    };
    if (!Utils.isEmptyArray(fieldOutlineIdUpdate)) {
        submitSoftDeleteTicketRequestDto.listFieldEdited = JSON.stringify(fieldOutlineIdUpdate);
        submitSoftDeleteTicketRequestDto.updateMethod = Constant.UPDATE_TICKET_METHOD.RESTORE_SDSCRIPT_DUPLICATE_TITLE;
    }
    return await editTicketData(API, submitSoftDeleteTicketRequestDto);
};

export const submitBackToDraftKnowledgeTicket = async (API, detailTicket, currentUserDetail) => {
    let submitBackToDraftKnowledgeTicketRequestDto = {
        ticketId: detailTicket.id,
        currentUserId: currentUserDetail.id,
        currentUserMail: currentUserDetail.mail,
        corporationId: currentUserDetail.affiliationOrganization,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_BACK_TO_DRAFT,
        ticketType: detailTicket.ticketType,
    };
    return await editTicketData(API, submitBackToDraftKnowledgeTicketRequestDto);
};

/**
 * 
 * @param {*} API 
 * @param {*} detailTicket 
 * @param {*} currentUserDetail 
 * @param {*} argsAll 
 */
export const submitSoftDelete = (API, detailTicket, currentUserDetail, argsAll, deletedAt = new Date().toISOString(), fieldOutlineIdUpdate = []) => {
    let updatedTime = moment(deletedAt || new Date().toISOString()).format('YYYY/MM/DD HH:mm');

    argsAll.setIsLoading(true);
    submitSoftDeleteKnowledgeTicket(API, detailTicket, deletedAt, currentUserDetail, argsAll, fieldOutlineIdUpdate)
        .then(async (result) => {
            if (!result || result?.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                argsAll.setIsLoading(false);
                argsAll.setIsOpenModalReloadPageMain(true);
            } else if ([Constant.MSG_SD_RESTORE_DUPLICATED_TITLE_SCRIPT, Constant.MSG_SD_RESTORE_DUPLICATED_APP_NAME].includes(result?.errorCode)) {
                // Restore duplicate name
                argsAll.setIsLoading(false);
                argsAll.setRestoreTicketErrorPopupData({
                    isOpen: true,
                    message: I18n.get(result?.errorCode)
                });
                return;
            } else {
                argsAll.reloadTicketListByPanelType({
                    panelType: getTicketListType(argsAll)
                        ? getTicketListType(argsAll)
                        : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
                });
                let msgNoti = deletedAt
                    ? I18n.get('MSG-CM-DELETE-CONTENT-SUCCESSFULLY') : I18n.get('MSG-CM-RESTORE-CONTENT-SUCCESSFULLY');
                argsAll.enqueueSnackbar(msgNoti, {
                    variant: 'success',
                    autoHideDuration: 3000
                });
        
                let newOutline = '';
                if (!Utils.isEmptyArray(fieldOutlineIdUpdate)) {
                    const newArgsAll = {...argsAll, isFromEditTicket: true}
                    let newTicketDetail = await getTicketDetailHandler(newArgsAll, detailTicket.id, argsAll.panelId, argsAll.tabId, argsAll.panelInitData, []);
                    argsAll.setDetailTicket(newTicketDetail);
                    newOutline = newTicketDetail.outline;
                } else {
                    argsAll.setDetailTicket({ ...detailTicket, deletedAt, updatedTime});
                }
                argsAll.setIsLoading(false);
                reloadPanelAfterSoftDeleteTicketKnowledge(
                    argsAll,
                    detailTicket.id,
                    result.updatedChildrenTicketIdList,
                    false,
                    deletedAt,
                    newOutline

                );
            }
        })
        .catch(err => {
            argsAll.setIsLoading(false);
            argsAll.reloadTicketListByPanelType({
                panelType: getTicketListType(argsAll)
                    ? getTicketListType(argsAll)
                    : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            });

            argsAll.enqueueSnackbar(I18n.get('SYSMSG001'), {
                variant: 'error',
                autoHideDuration: 3000
            });
        })
};

export const reloadPanelAfterSoftDeleteTicketKnowledge = (
    argsAll,
    ticketId,
    childrenTicketIdList = [],
    isDeleteDraftTicket = false,
    deletedAt,
    newOutline
) => {

    let newPanelList = _.cloneDeep(argsAll.panelList);

    // reload panel detail ticket
    let detailTicketPanelIndex = newPanelList.findIndex((panel) => panel.id === argsAll.panelId);
    if (detailTicketPanelIndex === -1) return;

    let tabList = newPanelList[detailTicketPanelIndex].tabList;
    
    let detailTicketTabIndex = tabList.findIndex(tab => tab.id === ticketId);
    if (detailTicketTabIndex === -1) return;

    // update ticketDetail
    deletedAt ?
        tabList[detailTicketTabIndex].isTicketDeleted = true
        : tabList[detailTicketTabIndex].isTicketDeleted = false;

    if (isDeleteDraftTicket) {
        newPanelList[detailTicketPanelIndex].isDraft = true;
        newPanelList[detailTicketPanelIndex].componentName = Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT;
        
        tabList[detailTicketTabIndex].isDraft = true;
    }
    
    // update ticket children's
    if (!Utils.isEmptyArray(childrenTicketIdList)) {
        childrenTicketIdList.forEach(childTicketId => {
            const openingTicketIndex = tabList.findIndex(t => t.id === childTicketId);
            if (openingTicketIndex !== -1) {
                deletedAt ?
                    tabList[openingTicketIndex].isTicketDeleted = true
                    : tabList[openingTicketIndex].isTicketDeleted = false;
            }
        })
    }
    newPanelList[detailTicketPanelIndex].tabList[detailTicketTabIndex].component.props.triggerReload = Date.now().toString();
    if (!Utils.isEmptyString(newOutline)) {
        newPanelList[detailTicketPanelIndex].tabList[detailTicketTabIndex].ticketOutline = newOutline;
    }
    //reload panel chat
    let chatThreadPanelIndex = newPanelList.findIndex((panel) => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD);
    if (chatThreadPanelIndex !== -1) {
        let tabChatList = newPanelList[chatThreadPanelIndex].tabList;
        let chatThreadTabIndex = tabChatList.findIndex(tab => tab.id === ticketId);
        if (chatThreadTabIndex !== -1) {
            deletedAt ?
                newPanelList[chatThreadPanelIndex].tabList[chatThreadTabIndex].isTicketDeleted = true
                : newPanelList[chatThreadPanelIndex].tabList[chatThreadTabIndex].isTicketDeleted = false;
            
            newPanelList[chatThreadPanelIndex].tabList[chatThreadTabIndex].component.props.triggerReload = Date.now().toString();
        }
    }
    argsAll.setPanelList(newPanelList);
}

/**
 * 
 * @param {*} event 
 * @param {*} reason 
 * @param {*} argsAll 
 * @returns 
 */
export const closeCallbackDeleteKnowledgeButton = (event, reason, argsAll) => {
    if (event && reason === 'backdropClick') {
        return false;
    }
    argsAll.setIsOpenDialogConfirmDeleteKnowledge(false);
}

/**
 * 
 * @param {*} argsAll 
 */
export const acceptDeleteKnowledgeButton = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsOpenDialogConfirmDeleteKnowledge(false);
    submitSoftDelete(API, detailTicket, currentUserDetail, argsAll)
}

export const closeCallbackRestoreKnowledgeTicketButton = (event, reason, argsAll) => {
    if (event && reason === 'backdropClick') {
        return false;
    }
    argsAll.setIsShowDialogRestoreTicket(false);
}

export const acceptRestoreKnowledgeTicket = (API, detailTicket, currentUserDetail, argsAll, fieldOutlineIdUpdate = []) => {
    if (Utils.isEmptyArray(fieldOutlineIdUpdate)) {
        argsAll.setIsShowDialogRestoreTicket(false);
    }
    submitSoftDelete(API, detailTicket, currentUserDetail, argsAll, null, fieldOutlineIdUpdate)
}

export const acceptHardDeleteKnowledgeTicket = async (API, detailTicket, currentUserDetail, argsAll, setIsOpenModalReloadPage, setDisplayMode) => {
    argsAll.setIsLoading(true);

    argsAll.setIsShowDialogDeleteTicket(false);

    try {
        const response = await deleteAllTicketData(API, {
            ticketId: detailTicket.id,
            currentUserId: currentUserDetail.id
        });

        if (!response || response?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR || !response.status) {
            argsAll.setIsLoading(false);
            setIsOpenModalReloadPage(true);
            return;
        }

        if (response.status) {

            // closePanelTab
            let closeListTabPanel = [{
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                panelId: argsAll.panelId,
                tabId: detailTicket.id,
            }];

            const chatPanel = argsAll?.panelList?.find(panel => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD);
            if (!Utils.isEmptyObject(chatPanel)) {
                closeListTabPanel = [...closeListTabPanel, {
                    panelType: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                    panelId: chatPanel.id,
                    tabId: detailTicket.id,
                }];
            }

            if (!Utils.isEmptyArray(response.removedChildrenTicketIdList)) {
                const knowledgeTicketDetailPanel = argsAll?.panelList?.find(panel => panel.id === argsAll.panelId);
                const removedChildrenTicketIdList = [...response.removedChildrenTicketIdList];
                const isOpeningChildTicketTabs = knowledgeTicketDetailPanel?.tabList?.filter(tab => removedChildrenTicketIdList.includes(tab.id));
                if (!Utils.isEmptyArray(isOpeningChildTicketTabs)) {
                    isOpeningChildTicketTabs.forEach(tab => {
                        closeListTabPanel = [...closeListTabPanel, {
                            panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                            panelId: argsAll.panelId,
                            tabId: tab.id,
                        }]
                    });
                }
            }

            argsAll.closePanelTab({
                event: null,
                isCloseMulti: true,
                closeList: [...closeListTabPanel]
            });

            argsAll.reloadTicketListByPanelType({
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            });

            // alert removed success
            argsAll.enqueueSnackbar(I18n.get('MSG-CM-COMPLETE-DELETE-CONTENT-SUCCESSFULLY'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }

    } catch (error) {
        console.log('acceptHardDeleteKnowledgeTicket error :>> ', error);
    }

    if (setDisplayMode) {
        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
    }

    argsAll.setIsLoading(false);
    hideLoadingMouse();
}

/**
 * 
 * @param {*} API 
 * @param {*} detailTicket 
 * @param {*} currentUserDetail 
 * @param {*} argsAll 
 */
export const submitBackToDraftKnowledge = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsLoading(true);
    submitBackToDraftKnowledgeTicket(API, detailTicket, currentUserDetail)
    .then((resolve, reject) => {
        argsAll.setIsLoading(false);
        argsAll.reloadTicketListByPanelType({
            panelType: getTicketListType(argsAll)
                ? getTicketListType(argsAll)
                : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
        });
        argsAll.enqueueSnackbar(I18n.get('MSG-CM-SAVE-DRAFT-TICKET-SUCCESS'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        argsAll.setDetailTicket(Object.assign(detailTicket, {public: Constant.TICKET_PUBLIC.DRAFT}));
        argsAll.reloadPanelAfterSoftDeleteTicketByPanelType({
            panelType: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
            id: detailTicket.id
        })

        argsAll.updatePanelAfterBackToDraft({
            panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            tabId: detailTicket.id,
            isDraft: true,
            panelId: argsAll.panelId,
            ticketId: detailTicket.id,
            ticketOutline: detailTicket.outline,
            API: API,
        })
    })
    .catch(err => {
        argsAll.setIsLoading(false);
        argsAll.reloadTicketListByPanelType({
            panelType: getTicketListType(argsAll)
                ? getTicketListType(argsAll)
                : Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
        });

        argsAll.enqueueSnackbar(I18n.get('SYSMSG001'), {
            variant: 'error',
            autoHideDuration: 3000
        });
    })
}

/**
 * 
 * @param {*} event 
 * @param {*} reason 
 * @param {*} argsAll 
 * @returns 
 */
export const closeCallbackBackToDraftButton = (event, reason, argsAll) => {
    if (event && reason === 'backdropClick') {
        return false;
    }
    argsAll.setIsOpenDialogConfirmBackToDraft(false);
} 

/**
 * 
 * @param {*} argsAll 
 */
export const acceptBackToDraftButton = (API, detailTicket, currentUserDetail, argsAll) => {
    argsAll.setIsOpenDialogConfirmBackToDraft(false);
    submitBackToDraftKnowledge(API, detailTicket, currentUserDetail, argsAll)
}


function getFileNameAndExtension(filePath) {
    var fileNameWithExtension = filePath.split('/').pop(); 
    var fileName = fileNameWithExtension.split('.').slice(0, -1).join('.'); 
    var fileExtension = fileNameWithExtension.split('.').pop();
  
    return {
      name: fileName,
      extension: fileExtension
    };
}

function areObjectsEqual(obj1, obj2) {
    // Lấy danh sách tất cả các key từ cả hai đối tượng
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    // Kiểm tra xem số lượng key có giống nhau không
    if (keys1.length !== keys2.length) {
        return false;
    }

    // Duyệt qua từng key và kiểm tra giá trị của mảng tương ứng
    for (let key of keys1) {
        // Kiểm tra xem key có tồn tại trong cả hai đối tượng không
        if (!obj2.hasOwnProperty(key)) {
            return false;
        }

        // So sánh giá trị của mảng tương ứng
        if (!Utils.areArraysEqual(obj1[key], obj2[key])) {
            return false;
        }
    }

    // Nếu không có sự khác biệt nào, trả về true
    return true;
}

export const handleOpenFileFromS3 = (file) => {
    let ticketDetail = Utils.convertJSONDataToObject(file.ticketDetail);
    ticketDetail = {
        ...ticketDetail,
        pageNo: file.pageNo
    };
    
    let fileUploadData = {
        ...file.dataValue,
        type: Constant.S3_FILE_TYPE.TICKET_FILE,
    };

    downloadFileFromS3(fileUploadData, ticketDetail, false, ticketDetail.ticketType === Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE);
}

export const isDisplayVectorUrlAndTotalToken = (corporationDetail, tabId) => {
    if (tabId && tabId.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET)) return;

    let isDisplay = false;
    if (Utils.isGuestContractType(corporationDetail)) {
        if (corporationDetail?.inviterUsingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON) isDisplay = true;
    } else {
        if (corporationDetail?.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON) isDisplay = true;
    }
    return isDisplay
}

export const isDisplayExtractText = (corporationDetail, tabId) =>{
    if ((tabId && tabId.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET)) || Utils.isEmptyObject(corporationDetail)) return;

    let isDisplay = false;
    if (Utils.isGuestContractType(corporationDetail)) {
        const inviterSettingObject = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting)
        if (inviterSettingObject.convertPDF === Constant.STATUS_SERVICE_PERMISSION.ON) isDisplay = true;
    } else {
        if (corporationDetail?.limitValue?.convertPDF === Constant.STATUS_SERVICE_PERMISSION.ON) isDisplay = true;
    }
    return isDisplay
}

export const handleConfirmAccessDenied = (setIsOpenAccessDeniedPopup) => {
    setIsOpenAccessDeniedPopup(false);
    window.location.reload();
}


/**
 * isShowExtractedTextAndVectorDataInFileAndPageKnowledge
 * is show extracted text in detail file and page
 * @param {*} isShowExtractedText 
 * @param {*} affiliationOrganizationDetail 
 * @param {*} hasEditSettingPermissions 
 * @param {*} hasEditFieldPermissions 
 * @returns 
 */
export const isShowExtractedTextAndVectorDataInFileAndPageKnowledge = (affiliationOrganizationDetail, hasEditSettingPermissions, hasEditFieldPermissions) => {
    if (Utils.isEmptyObject(affiliationOrganizationDetail)) return false;
    let convertPDFStatus = false;
    let usingAIStatus = false;

    if (Utils.isGuestContractType(affiliationOrganizationDetail)) {
        const inviterSettingObject = Utils.convertJSONDataToObject(affiliationOrganizationDetail.inviterSetting)
        if (inviterSettingObject.convertPDF === Constant.STATUS_SERVICE_PERMISSION.ON) convertPDFStatus = true;
        if (inviterSettingObject.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON) usingAIStatus = true;
    } else {
        if (affiliationOrganizationDetail.limitValue?.convertPDF === Constant.STATUS_SERVICE_PERMISSION.ON) convertPDFStatus = true;
        if (affiliationOrganizationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON) usingAIStatus = true;
    }

    if (!convertPDFStatus && !usingAIStatus) return false;
    if (hasEditSettingPermissions || hasEditFieldPermissions) return true;

    return false;
}

export const handleOpenTicketDetail = async (
    ticketId,
    ticketType,
    sysField,
    outline,
    setIsLoading,
    currentUserDetail,
    projectInuseDetail,
    setIsOpenAccessDeniedPopup,
    addNewPanel,
    panelId,
    isCustomer
) => {

    if (!ticketId) return;

    setIsLoading(true);

    const getViewTicketDetail = await getTicketById(null, ticketId);
    
    setIsLoading(false);

    let isNotCreatorDraftedTicket =
        getViewTicketDetail?.public === Constant.TICKET_PUBLIC.DRAFT &&
        currentUserDetail.id !== getViewTicketDetail.creator;

    let isValid = hasKnowledgeChatPermissionInChatThread(
        getViewTicketDetail,
        projectInuseDetail,
        currentUserDetail?.id,
        true
    );
    if (!isValid || isNotCreatorDraftedTicket) {
        setIsLoading(true);
        setIsOpenAccessDeniedPopup(true);
        return;
    }

    let addPanelOutline = outline;
    if (Utils.isEmptyString(addPanelOutline)) {
        addPanelOutline = getViewTicketDetail?.outline
    }


    let knowledgeAddNewPanel = {
        type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
        panelId: panelId,
        isCustomer: isCustomer ? isCustomer : getViewTicketDetail?.affiliationProject !== projectInuseDetail.id,
        isViewByList: false,
        ticketId: ticketId,
        tabId: ticketId,
        ticketOutline: addPanelOutline,
        isTicketDeleted: !Utils.isEmptyString(getViewTicketDetail?.deletedAt) ? true : false
    };

    if (ticketType == Constant.TICKET_TYPE.PDF_FILE_KNOWLEDGE && sysField === 'parent') {
        addNewPanel(knowledgeAddNewPanel);
        return;
    } else {
        knowledgeAddNewPanel.isPDFKnowledge = true;
        addNewPanel(knowledgeAddNewPanel);
        return;
    }
};

export const isDisplayHyperLinkFileKnowledge = (file, isOnServicesPDF) => {
    return (
        file.isPdf
        && file.idTicketFileKnowledge
        && !file.isPrivate
        && isOnServicesPDF === Constant.STATUS_SERVICE_PERMISSION.ON
    );
}



export const getAiAutoLog = async (args, ticketId) => {
    let params = {
        corporationInuse: args.corporationDetail.id,
        projectInuse: args.selectedProject.id,
        userId: args.currentUserDetail.id,
        ticketId: ticketId,
        actionType: Constant.AI_AUTO_LOG.GET_LIST_PAGINATION,
        queryParams: ''
    }

    if (args?.lastEvaluatedKey) {
        params.queryParams = {lastEvaluatedKey: args?.lastEvaluatedKey}
    }

    if (args?.limit) {
        params.queryParams = {...params.queryParams, limit: args?.limit}
    }
    
    params.queryParams = JSON.stringify(params.queryParams);

    const response = await getAiAutoLogByTicketId(params);
    if (response && response.success) {
        const payload = Utils.convertJSONDataToObject(response.payload);
        const listLog = payload.listItem || []
        return {listLog, error: ''};
    }
    return {listLog: [], error: response?.error || Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR};
}

export const getAiOperatorPromptLog = async (args, ticketId) => {
    let params = {
        corporationInuse: args.corporationDetail.id,
        projectInuse: args.selectedProject.id,
        userId: args.currentUserDetail.id,
        ticketId: ticketId,
        actionType: Constant.AI_AUTO_LOG.GET_LIST_OPERATOR_PROMPT_LOG,
        queryParams: ''
    }

    if (args?.lastEvaluatedKey) {
        params.queryParams = {lastEvaluatedKey: args?.lastEvaluatedKey}
    }

    if (args?.limit) {
        params.queryParams = {...params.queryParams, limit: args?.limit}
    }
    
    params.queryParams = JSON.stringify(params.queryParams);

    const response = await getAiAutoLogByTicketId(params);
    if (response && response.success) {
        const payload = Utils.convertJSONDataToObject(response.payload);
        const listLog = payload.listItem || [];
        return { listLog, error: '', lastEvaluatedKey: payload?.lastEvaluatedKey };
    }
    return {
        listLog: [],
        error: response?.error || Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR,
        lastEvaluatedKey: null
    };
}

export const retryQueryListAiAutoLog = async (args, ticketId, listLogId = []) => {
    if (Utils.isEmptyArray(listLogId)) return {
        listLog: [], error: Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR
    };

    let params = {
        corporationInuse: args.corporationDetail.id,
        projectInuse: args.selectedProject.id,
        userId: args.currentUserDetail.id,
        ticketId: ticketId,
        actionType: Constant.AI_AUTO_LOG.RETRY_GET_LIST_LOG,
        queryParams: ''
    }

    params.queryParams = JSON.stringify({
        listLogId: listLogId
    })

    const response = await getAiAutoLogByTicketId(params);
    if (response && response.success) {
        const payload = Utils.convertJSONDataToObject(response.payload);
        const listLog = payload || []
        return { listLog, error: ''};
    }

    return { listLog: [], error: response?.error || Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR };
}

/**
 * Check edit permission for special fields that require PM role
 * Special fields: SDAUTO API settings, Telephone HUMAN_SCORE, Telephone HUMAN_EVALUATION
 * Rule: Only PM can edit these fields, members can only view
 * @param {Object} fieldData - Field data object
 * @param {Object} detailTicket - Ticket detail object
 * @param {Object} projectInuseDetail - Project in use detail object
 * @param {boolean} isProjectManager - Whether user is project manager
 * @param {string} displayMode - Display mode (EDIT/VIEW)
 * @param {boolean} isDuplicate - Whether this is duplicate operation
 * @returns {boolean} True if user has edit permission, false otherwise
 */
export const hasEditPermissionWithSpecialCase = (fieldData, detailTicket, projectInuseDetail, isProjectManager, displayMode, isDuplicate = false) => {
    // Fix cannot edit caller language and receiver language in ticket detail
    if ([
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALLER_LANGUAGE,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.RECEIVER_LANGUAGE,
    ].includes(fieldData?.sysField)) {
        return false;
    }
    
    if (
        fieldData?.sysField === TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FOLLOW_UP_STATUS &&
        detailTicket?.ticketType === Constant.TICKET_TYPE.TELEPHONE
    ) {
        const telephoneStatus = getTelephoneStatusFromTicket(detailTicket);
        if ([
            TelephoneConstant.TELEPHONE_CALL_STATUS.CALL_WAITING,
            TelephoneConstant.TELEPHONE_CALL_STATUS.DURING_CALL
        ].includes(telephoneStatus)) {
            return false;
        }
    }

    if ([
        Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING,
        Constant.SD_AUTO.SYSTEM_FIELD.SDAUTO_CALL_SCRIPT_API_SETTING_TARGET
    ].includes(fieldData?.sysField)) {
        if (!isProjectManager) return false; // check createNew / edit
        if (!isDuplicate && detailTicket && detailTicket.affiliationProject !== projectInuseDetail.id) return false; // check when edit / draft
    }
    return displayMode === Constant.DISPLAY_MODE.EDIT;
};
